<template>
  <div>
    <div class="right_font"><span @click="addPlugin" class="icon-portal-plus-small plugin_title"></span></div>
    <div v-for="(item, index) in pluginName" :key="index" class="mt8 plugins">
      <span class="plugin_title mr8">插件名</span>
      <el-input
        class="mr8"
        style="width: 154px"
        :value="item"
        @input="changePluginName(index, $event)"
        placeholder="请输入插件名"
      ></el-input>
      <span @click="delPlugin(index)" class="plugin_title icon-portal-delete"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "element-plugin-setting",
  props: {
    myid: {
      type: Object
    },
    pluginName: {
      default: [],
      type: Array
    }
  },
  methods: {
    changePluginName(index, name) {
      this.$changeOptionsEV(name, "pluginName." + index, false, null, this.myid)
    },
    delPlugin(index) {
      const pluginName = [...this.pluginName]
      pluginName.splice(index, 1)
      this.$changeOptionsEV(pluginName, "pluginName", false, null, this.myid)
    },
    addPlugin() {
      this.$changeOptionsEV("", "pluginName." + this.pluginName.length, false, null, this.myid)
    }
  }
}
</script>
